import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[sliderItem]',
  standalone: true,
})
export class SliderItemDirective {

  public slideData: unknown;

  @Input('sliderItem')
  set data(value: unknown) {
    this.slideData = value;
  }

  constructor(
    public tpl: TemplateRef<unknown>
  ) { }

}
